import { styled } from 'styled-components'

export const NotesWrapper = styled.div`
    width: 100%;
    padding: ${props => `0 ${props.theme.padding}px`};
    display: flex;
    flex-direction: column;
    gap: ${props => `${props.theme.marginXS}px`};
`

export const HeaderWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const NotesList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${props => `${props.theme.marginXS}px`};
`

export const AddNoteWrapper = styled.form`
    width: 100%;
    display: flex;
    align-items: flex-end;
    gap: ${props => `${props.theme.marginXS}px`};
`

// The vertical step (px) between the front card and each stacked page behind it.
// Single tunable value for the whole stack — every layer keeps the card's height and
// peeks exactly this far below the one in front (4px collapses into a solid block).
const STACK_STEP = 4

// The collapsed view: the newest note on top with a few "pages" peeking behind it
// to hint that there are more notes. Clicking expands the full list.
type StackAreaProps = {
  $peekSize: number
}

export const StackArea = styled.div<StackAreaProps>`
    position: relative;
    width: 100%;
    // reserve room at the bottom equal to peekSize steps so every layer (including the
    // front card) keeps the same height and peeks one uniform step below the previous
    padding-bottom: ${props => `${STACK_STEP * props.$peekSize}px`};
    isolation: isolate;
    cursor: pointer;
`

type StackLayerProps = {
  $index: number
  $peekSize: number
}

// A decorative page behind the top note. Every layer is the same size as the card
// (top:0 .. bottom = peekSize steps, inset one step per side) and is nudged down by a
// single uniform offset per layer (translateY). So the gap between the card and the
// first page equals the gap between pages, horizontally and vertically. `STACK_STEP`
// is the one value that drives the whole stack.
export const StackLayer = styled.div<StackLayerProps>`
    position: absolute;
    top: 0;
    bottom: ${props => `${props.$peekSize * STACK_STEP}px`};
    left: ${props => `${props.$index * STACK_STEP}px`};
    right: ${props => `${props.$index * STACK_STEP}px`};
    transform: translateY(${props => props.$index * STACK_STEP}px);
    background-color: ${props => props.theme.colorBorder};
    border: solid 1px ${props => props.theme.colorBorderSecondary};
    border-radius: ${props => `${props.theme.borderRadiusLG}px`};
    z-index: ${props => 3 - props.$index};
    pointer-events: none;
`

export const NoteCard = styled.div`
    width: 100%;
    background-color: ${props => props.theme.colorBgLayout};
    border: solid 1px ${props => props.theme.colorBorderSecondary};
    border-radius: ${props => `${props.theme.borderRadiusLG}px`};
    padding: ${props => `${props.theme.marginXS}px`};
`

//the front card of the collapsed stack: positioned + raised so it sits above the peeking layers.
//the z-index is intentionally scoped here (StackArea isolates it) — the expanded-list NoteCard must
//NOT carry it, or list notes paint above the add-note form on any overlap
export const StackFrontCard = styled(NoteCard)`
    position: relative;
    z-index: 4;
`

export const NoteHeader = styled.div`
    width: 100%;
    margin-top: ${props => `${props.theme.marginXS}px`};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${props => `${props.theme.marginXS}px`};
`

export const NoteMeta = styled.div`
    display: flex;
    align-items: center;
    gap: ${props => `${props.theme.marginXXS}px`};
    min-width: 0; // allow the author name to truncate instead of overflowing the card
`
